import React, { createContext } from "react";
import { IGridField } from "../components/Interfaces/TableInterface";

export interface IFieldsContextProps {
    fields: IGridField[];
    setFields: (fields: IGridField[]) => void;
    customSizing: boolean;
    setCustomSizing: (customSizing: boolean) => void;
    columnTotalWidth: number;
}

export const FieldContext = createContext < IFieldsContextProps > ({} as IFieldsContextProps);
